import React, { useEffect, useState } from 'react';
import { getHarcamaSecenekleri, harcamaKaydet } from '../services/api';

// Harcama giriş formu. İKİ ekran da bunu kullanır:
//   "Harcama Kaydı"          (YETK_WEB_9)  — sayfanın kendisi
//   "Harcama Kaydı Gelişmiş" (YETK_WEB_10) — popup içinde
// Tek kopya olması, ileride alan eklenince iki ekranın ayrışmamasını sağlar.

export const bugun = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

export const suAn = () => {
  const d = new Date();
  return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
};

export const paraFormat = (n) =>
  new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n ?? 0);

// Kullanıcı "1.234,56" da yazabilir "1234.56" da. Binlik ayracı atılır, virgül noktaya çevrilir.
// Geçersizse null döner.
const tutarCozumle = (ham) => {
  if (!ham) return null;
  const temiz = ham.trim().replace(/\s/g, '').replace(/\./g, '').replace(',', '.');
  if (!/^\d+(\.\d{1,2})?$/.test(temiz)) return null;
  const n = parseFloat(temiz);
  return n > 0 ? n : null;
};

const etiket = {
  fontSize: 11,
  fontWeight: 700,
  color: 'var(--med-primary)',
  display: 'block',
  marginBottom: 5,
  textTransform: 'uppercase',
  letterSpacing: '.4px',
};

const simdiBtn = {
  background: 'var(--med-light)',
  border: '1px solid var(--border)',
  borderRadius: 6,
  cursor: 'pointer',
  fontSize: 14,
  padding: '0 10px',
  flexShrink: 0,
};

// onKaydedildi: kayıt başarılı olunca çağrılır (Gelişmiş ekran listeyi tazelemek için kullanır).
// sonucuGoster: false ise başarı kutusunu form kendi göstermez (popup kendi kapanır).
export default function HarcamaFormu({ onKaydedildi, sonucuGoster = true, iptalEt }) {
  const [tarih, setTarih] = useState(bugun());
  const [saat, setSaat] = useState(suAn());
  const [tutar, setTutar] = useState('');
  const [aciklama, setAciklama] = useState('');
  const [kasaKod, setKasaKod] = useState('');
  const [kategoriKod, setKategoriKod] = useState('');

  const [kasalar, setKasalar] = useState([]);
  const [kategoriler, setKategoriler] = useState([]);
  const [kaydediliyor, setKaydediliyor] = useState(false);
  const [hata, setHata] = useState('');
  const [sonuc, setSonuc] = useState(null);

  useEffect(() => {
    getHarcamaSecenekleri()
      .then(res => {
        setKasalar(res.data.kasalar || []);
        setKategoriler(res.data.kategoriler || []);
      })
      .catch(() => setHata('Kasa ve kategori listeleri yüklenemedi.'));
  }, []);

  const kaydet = async (e) => {
    e.preventDefault();
    setHata('');
    setSonuc(null);

    const tutarSayi = tutarCozumle(tutar);
    if (!tarih) { setHata('Tarih seçiniz.'); return; }
    if (!saat) { setHata('Saat giriniz.'); return; }
    if (tutarSayi === null) { setHata('Harcama tutarı geçersiz. Örnek: 1250,50'); return; }
    if (!aciklama.trim()) { setHata('Açıklama giriniz.'); return; }
    if (!kasaKod) { setHata('Çıkış kasası seçiniz.'); return; }
    if (!kategoriKod) { setHata('Kategori seçiniz.'); return; }

    setKaydediliyor(true);
    try {
      const res = await harcamaKaydet({
        tarih,
        saat,
        tutar: tutarSayi,
        aciklama: aciklama.trim(),
        cikisKasasiKod: Number(kasaKod),
        kategoriKod: Number(kategoriKod),
        // whoNo GÖNDERİLMEZ: CHI.WHONO / MASTERJOB.WHONO sunucuda oturum jetonundan okunur.
      });
      setSonuc(res.data);
      // Kayıt sonrası form temizlenir, tarih/saat yeniden anlık değere döner —
      // arka arkaya harcama girmek kolay olsun.
      setTutar('');
      setAciklama('');
      setKasaKod('');
      setKategoriKod('');
      setTarih(bugun());
      setSaat(suAn());
      if (onKaydedildi) onKaydedildi(res.data);
    } catch (err) {
      setHata(err.response?.data?.hata || 'Harcama kaydedilemedi.');
    } finally {
      setKaydediliyor(false);
    }
  };

  return (
    <>
      <form onSubmit={kaydet}>
        <div style={{ marginBottom: 14 }}>
          <label style={etiket}>Tarih ve Saat</label>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            <input type="date" value={tarih} onChange={e => setTarih(e.target.value)} required
                   style={{ flex: '1 1 160px', minWidth: 0 }} />
            <input type="time" value={saat} onChange={e => setSaat(e.target.value)} required
                   style={{ flex: '0 1 120px', minWidth: 0 }} />
            <button type="button" onClick={() => { setTarih(bugun()); setSaat(suAn()); }}
                    title="Tarih ve saati şu ana ayarla" style={simdiBtn}>⏱</button>
          </div>
        </div>

        <div style={{ marginBottom: 14 }}>
          <label style={etiket}>Harcama Tutarı</label>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            <input type="text" inputMode="decimal" value={tutar} onChange={e => setTutar(e.target.value)}
                   placeholder="0,00" required
                   style={{ flex: 1, minWidth: 0, textAlign: 'right', fontWeight: 600 }} />
            <span style={{ color: 'var(--text-muted)', fontSize: 13, fontWeight: 600 }}>TL</span>
          </div>
        </div>

        <div style={{ marginBottom: 14 }}>
          <label style={etiket}>Açıklama</label>
          <textarea value={aciklama} onChange={e => setAciklama(e.target.value)} rows={4} maxLength={255} required
                    style={{ width: '100%', resize: 'vertical' }} />
        </div>

        <div style={{ marginBottom: 14 }}>
          <label style={etiket}>Çıkış Kasası</label>
          <select value={kasaKod} onChange={e => setKasaKod(e.target.value)} required>
            <option value="">LÜTFEN SEÇİNİZ</option>
            {kasalar.map(k => <option key={k.kod} value={k.kod}>{k.adi}</option>)}
          </select>
        </div>

        <div style={{ marginBottom: 18 }}>
          <label style={etiket}>Kategorisi</label>
          <select value={kategoriKod} onChange={e => setKategoriKod(e.target.value)} required>
            <option value="">LÜTFEN SEÇİNİZ</option>
            {kategoriler.map(k => <option key={k.kod} value={k.kod}>{k.adi}</option>)}
          </select>
        </div>

        {hata && <div className="hata-kutu">{hata}</div>}

        <div style={{ display: 'flex', gap: 8 }}>
          <button type="submit" className="btn btn-primary" disabled={kaydediliyor} style={{ flex: 1 }}>
            {kaydediliyor ? 'KAYDEDİLİYOR...' : '👍 KAYDET'}
          </button>
          {iptalEt && (
            <button type="button" className="btn btn-secondary" onClick={iptalEt} disabled={kaydediliyor}>
              Kapat
            </button>
          )}
        </div>
      </form>

      {sonucuGoster && sonuc && (
        <div className="basari-kutu" style={{ marginTop: 16 }}>
          <div style={{ fontWeight: 700, marginBottom: 6 }}>Harcama kaydedildi.</div>
          <div style={{ fontSize: 13, lineHeight: 1.7 }}>
            <div>Belge No: <strong>{sonuc.evrakNo}</strong></div>
            <div>Tutar: <strong>{paraFormat(sonuc.tutar)} TL</strong> — {sonuc.kategoriAdi}</div>
            <div>Çıkış Kasası: <strong>{sonuc.kasaAdi}</strong></div>
            <div>Kasanın yeni bakiyesi: <strong>{paraFormat(sonuc.yeniBakiye)} TL</strong></div>
          </div>
        </div>
      )}
    </>
  );
}
